import { List } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import OptionConfigurationModal from '../common/optionConfiguration/OptionConfigurationModal';
import { jsx as _jsx } from "react/jsx-runtime";
const BaseEditTableMetricsModal = ({
  closeModal,
  onSubmit,
  options,
  selectedMetrics: initialSelectedMetrics
}) => {
  return /*#__PURE__*/_jsx(OptionConfigurationModal, {
    closeModal: closeModal,
    onSubmit: selectedValues => {
      onSubmit(List(selectedValues));
    },
    options: options,
    orderColumnLabelKey: 'reporting-enablement.reportEditors.tableMetrics.edit.metricOrderLabel',
    SelectionColumnLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-enablement.reportEditors.tableMetrics.edit.metricSelectLabel"
    }),
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-enablement.reportEditors.tableMetrics.edit.title"
    }),
    value: initialSelectedMetrics
  });
};
export default BaseEditTableMetricsModal;